import {AuthService} from "./AuthService";

export class SiteSearchSummaryService {

    // GET site_search_summary/product/?product_id=<id>&target=competitor|supplier
    // -> [{host, target, status, searched_at, keyword, url, found, suggested}], newest first.
    // `status` is suggested | nothing_new | zero_results | unreachable; `url` always opens a
    // page a person can read (the site's own search results, or its homepage).
    getProductSiteSearchSummary(productId, target) {
        return AuthService.apiGet(`site_search_summary/product/?product_id=${productId}&target=${target}`)
            .then(res => res.data.data);
    }
}
